import { useEffect } from 'react';

import { catalogStore } from '~/stores/CatalogStore';

export const useRewardedPromocodesStatus = () => {
  useEffect(() => {
    catalogStore.promotionStore.getRewardedPromocodesStatus();
  }, []);
};
